import {
  // User actions
  subscribe, unsubscribe,
  sendSubscriptionRequest, revokeSentRequest,
  ban, unban,

  // Post actions
  showMoreComments, showMoreLikes,
  addAttachmentResponse, removeAttachment,
  likePost, unlikePost,
  hidePost, unhidePost,
  savePost, unsavePost,
  toggleModeratingComments,
  disableComments, enableComments,
  toggleEditingPost, cancelEditingPost, saveEditingPost,
  deletePost,

  // Comment actions
  toggleCommenting, addComment,
  toggleEditingComment, saveEditingComment,
  updateHighlightedComments,
  getCommentLikes, likeComment, unlikeComment,
  deleteComment
} from '../redux/action-creators';

export function joinCreatePostData(state) {
  const createPostForm = state.createPostForm;
  return { ...createPostForm,
    attachments: (createPostForm.attachments || []).map(attachmentId => state.attachments[attachmentId])
  };
}

export function postActions(dispatch) {
  return {
    showMoreComments: (postId) => dispatch(showMoreComments(postId)),
    showMoreLikes: (postId) => dispatch(showMoreLikes(postId)),
    toggleEditingPost: (postId) => dispatch(toggleEditingPost(postId)),
    cancelEditingPost: (postId) => dispatch(cancelEditingPost(postId)),
    saveEditingPost: (postId, newPost) => dispatch(saveEditingPost(postId, newPost)),
    deletePost: (postId) => dispatch(deletePost(postId)),
    toggleCommenting: (postId) => dispatch(toggleCommenting(postId)),
    addComment: (postId, commentText) => dispatch(addComment(postId, commentText)),
    likePost: (postId, userId) => dispatch(likePost(postId, userId)),
    unlikePost: (postId, userId) => dispatch(unlikePost(postId, userId)),
    hidePost: (postId) => dispatch(hidePost(postId)),
    unhidePost: (postId) => dispatch(unhidePost(postId)),
    savePost: (postId) => dispatch(savePost(postId)),
    unsavePost: (postId) => dispatch(unsavePost(postId)),
    toggleModeratingComments: (postId) => dispatch(toggleModeratingComments(postId)),
    disableComments: (postId) => dispatch(disableComments(postId)),
    enableComments: (postId) => dispatch(enableComments(postId)),
    addAttachmentResponse: (postId, attachments) => dispatch(addAttachmentResponse(postId, attachments)),
    removeAttachment: (postId, attachmentId) => dispatch(removeAttachment(postId, attachmentId)),
    commentEdit: {
      toggleEditingComment: (commentId) => dispatch(toggleEditingComment(commentId)),
      saveEditingComment: (commentId, newValue) => dispatch(saveEditingComment(commentId, newValue)),
      updateHighlightedComments: (...args) => dispatch(updateHighlightedComments(...args)),
      getCommentLikes: (...args) => dispatch(getCommentLikes(...args)),
      likeComment: (commentId) => dispatch(likeComment(commentId)),
      unlikeComment: (commentId) => dispatch(unlikeComment(commentId)),
      deleteComment: (commentId) => dispatch(deleteComment(commentId))
    },
  };
}

export function userActions(dispatch) {
  return {
    ban: (payload) => dispatch(ban(payload)),
    unban: (payload) => dispatch(unban(payload)),
    subscribe: (payload) => dispatch(subscribe(payload)),
    unsubscribe: (payload) => dispatch(unsubscribe(payload)),
    sendSubscriptionRequest: (payload) => dispatch(sendSubscriptionRequest(payload)),
    revokeSentRequest: (payload) => dispatch(revokeSentRequest(payload))
  };
}
